import { urlManager } from 'services/api/config';

const getOriginURL = (origin: string, pathName: string) => {
  const { homepage } = urlManager;

  return `${origin}${homepage}${pathName}`;
};

export default getOriginURL;
